/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UserDeviceResponse } from '../models/UserDeviceResponse';
import type { UserDevicesResponse } from '../models/UserDevicesResponse';
import type { UserDeviceUpdateRequest } from '../models/UserDeviceUpdateRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DevicesService {
    /**
     * Get current user's devices
     * Get all devices associated with the authenticated user
     * @param userSession
     * @returns UserDevicesResponse Successful Response
     * @throws ApiError
     */
    public static getUserDevices(
        userSession?: (string | null),
    ): CancelablePromise<UserDevicesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/devices/',
            cookies: {
                'user_session': userSession,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete a device
     * Delete a device owned by the authenticated user
     * @param deviceId
     * @param userSession
     * @returns void
     * @throws ApiError
     */
    public static deleteUserDevice(
        deviceId: string,
        userSession?: (string | null),
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/devices/{device_id}',
            path: {
                'device_id': deviceId,
            },
            cookies: {
                'user_session': userSession,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update a device
     * Update a device owned by the authenticated user
     * @param deviceId
     * @param requestBody
     * @param userSession
     * @returns UserDeviceResponse Successful Response
     * @throws ApiError
     */
    public static updateUserDevice(
        deviceId: string,
        requestBody: UserDeviceUpdateRequest,
        userSession?: (string | null),
    ): CancelablePromise<UserDeviceResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/devices/{device_id}',
            path: {
                'device_id': deviceId,
            },
            cookies: {
                'user_session': userSession,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
